const id_master_profile = {
    "": "profil",
    add: "tambah profil",
    edit: "ubah profil",

    label: {
        name: 'nama profil',
    },

    error: {
        name: "Nama profil tidak boleh kosong.",
        menu_list: "Minimal terdapat 1 akses menu.",
        menu_list_min: "Minimal terdapat 1 item akun untuk membuat menu.",
        create: "Gagal membuat profil.",
        delete: "Gagal menghapus profil.",
        edit: "Gagal mengubah profil.",
    },

    success: {
        create: "Berhasil membuat profil.",
        delete: "Berhasil menghapus profil.",
        edit: "Berhasil mengubah profil.",
    },

    menu: {
        cekgudang: "CEKGUDANG",
        fasilitas: "FASILITAS",
        fasilitas_daftar_fasilitas: "FASILITAS - DAFTAR FASILITAS",
        fasilitas_daftar_permohonan: "FASILITAS - DAFTAR PERMOHONAN",
        fasilitas_kategori_fasilitas: "FASILITAS - KATEGORI FASILITAS",
        kontrak: "KONTRAK",
        laporan: "LAPORAN",
        laporan_delivery_order: "LAPORAN - DELIVERY ORDER",
        laporan_detail_delivery_order: "LAPORAN - DETAIL DELIVERY ORDER",
        laporan_detail_penjualan: "LAPORAN - DETAIL PENJUALAN",
        laporan_detail_sales_order: "LAPORAN - DETAIL SALES ORDER",
        laporan_grup: "LAPORAN - GRUP",
        laporan_hpp_jual: "LAPORAN - HPP JUAL",
        laporan_komisi_sales: "LAPORAN - KOMISI SALES",
        laporan_nilai_stock_barang: "LAPORAN - NILAI STOCK BARANG",
        laporan_pembayaran_pembelian: "LAPORAN - PEMBAYARAN PEMBELIAN",
        laporan_pembayaran_penjualan: "LAPORAN - PEMBAYARAN PENJUALAN",
        laporan_pembelian: "LAPORAN - PEMBELIAN",
        laporan_pengiriman: "LAPORAN - PENGIRIMAN",
        laporan_penjualan: "LAPORAN - PENJUALAN",
        laporan_retur_pembelian: "LAPORAN - RETUR PEMBELIAN",
        laporan_retur_penjualan: "LAPORAN - RETUR PENJUALAN",
        laporan_sales_order: "LAPORAN - SALES ORDER",

        mitra_scm_online: "MITRA SCM ONLINE",
        mitra_scm_online_cari_mitra: "MITRA SCM ONLINE - CARI MITRA",
        mitra_scm_online_daftar_mitra: "MITRA SCM ONLINE - DAFTAR MITRA",
        mitra_scm_online_permintaan_barang: "MITRA SCM ONLINE - PERMINTAAN BARANG",

        pembayaran: "PEMBAYARAN",
        pembayaran_debit: "PEMBAYARAN - DEBIT",
        pembayaran_kredit: "PEMBAYARAN - KREDIT",

        pembelian: "PEMBELIAN",
        pembelian_barang_masuk: "PEMBELIAN - BARANG MASUK",
        pembelian_detail_flow_pembelian: "PEMBELIAN - DETAIL FLOW PEMBELIAN",
        pembelian_permintaan_penawaran: "PEMBELIAN - PERMINTAAN PENAWARAN",
        pembelian_purchase_order_keluar: "PEMBELIAN - PURCHASE ORDER KELUAR",
        pembelian_rekap_tagihan_pembelian: "PEMBELIAN - REKAP TAGIHAN PEMBELIAN",
        pembelian_retur_pemasok: "PEMBELIAN - RETUR PEMASOK",
        pembelian_tagihan_pembelian: "PEMBELIAN - TAGIHAN PEMBELIAN",

        pengaturan: "PENGATURAN",
        pengaturan_atribut: "PENGATURAN - ATRIBUT",
        pengaturan_barang: "PENGATURAN - BARANG",
        pengaturan_gudang: "PENGATURAN - PENGATURAN GUDANG",
        pengaturan_kategori: "PENGATURAN - KATEGORI",
        pengaturan_kategori_keuangan: "PENGATURAN - KATEGORI KEUANGAN",
        pengaturan_kebijakan_dan_ketentuan: "PENGATURAN - KEBIJAKAN DAN KETENTUAN",
        pengaturan_keuangan: "PENGATURAN - KEUANGAN",
        pengaturan_konversi_barang: "PENGATURAN - KONVERSI BARANG",
        pengaturan_kurir: "PENGATURAN - KURIR",
        pengaturan_metode_pembayaran: "PENGATURAN - METODE PEMBAYARAN",
        pengaturan_pelanggan: "PENGATURAN - PELANGGAN",
        pengaturan_pemasok: "PENGATURAN - PEMASOK",
        pengaturan_pengguna: "PENGATURAN - PENGGUNA",
        pengaturan_profil: "PENGATURAN - PROFIL",
        pengaturan_proses: "PENGATURAN - PROSES",
        pengaturan_rekening_bank: "PENGATURAN - REKENING BANK",
        pengaturan_ruang_penyimpanan: "PENGATURAN - RUANG PENYIMPANAN",
        pengaturan_sales: "PENGATURAN - SALES",
        pengaturan_satuan: "PENGATURAN - SATUAN",
        pengaturan_tag_barang: "PENGATURAN - TAG BARANG",
        pengaturan_tingkat_harga: "PENGATURAN - TINGKAT HARGA",

        penjualan: "PENJUALAN",
        penjualan_daftar_harga_stock: "PENJUALAN - DAFTAR HARGA & STOCK",
        penjualan_delivery_order: "PENJUALAN - DELIVERY ORDER",
        penjualan_penawaran: "PENJUALAN - PENAWARAN",
        penjualan_rekap_tagihan_penjualan: "PENJUALAN - REKAP TAGIHAN PENJUALAN",
        penjualan_retur_pelanggan: "PENJUALAN - RETUR PELANGGAN",
        penjualan_sales_order: "PENJUALAN - SALES ORDER",
        penjualan_tagihan_penjualan: "PENJUALAN - TAGIHAN PENJUALAN",

        perencanaan_anggaran: "PERENCANAAN ANGGARAN",
        perencanaan_anggaran_perencanaan: "PERENCANAAN ANGGARAN - PERENCANAAN",

        rantai_pasokan: "RANTAI PASOKAN",
        rantai_pasokan_permintaan_barang: "RANTAI PASOKAN - PERMINTAAN BARANG",
        rantai_pasokan_titik_distribusi: "RANTAI PASOKAN - TITIK DISTRIBUSI",

        stock_barang: "STOCK BARANG",
        stock_barang_barang_keluar: "STOCK BARANG - BARANG KELUAR",
        stock_barang_barang_masuk: "STOCK BARANG - BARANG MASUK",
        stock_barang_nomor_seri: "STOCK BARANG - NOMOR SERI",
        stock_barang_perpindahan_barang: "STOCK BARANG - PERPINDAHAN BARANG",
        stock_barang_retur_pelanggan: "STOCK BARANG - RETUR PELANGGAN",
        stock_barang_retur_pemasok: "STOCK BARANG - RETUR PEMASOK",

        transaksi_gudang: "TRANSAKSI GUDANG",
        transaksi_gudang_barang_keluar: "TRANSAKSI GUDANG - BARANG KELUAR",
        transaksi_gudang_barang_masuk: "TRANSAKSI GUDANG - BARANG MASUK",
        transaksi_gudang_konversi: "TRANSAKSI GUDANG - KONVERSI",
        transaksi_gudang_perpindahan_barang: "TRANSAKSI GUDANG - PERPINDAHAN BARANG",
        transaksi_gudang_proses_barang: "TRANSAKSI GUDANG - PROSES BARANG",
        transaksi_gudang_stock_awal: "TRANSAKSI GUDANG - STOCK AWAL",
        transaksi_gudang_stock_opname: "TRANSAKSI GUDANG - STOCK OPNAME",
        transaksi_gudang_supervisi_barang_keluar: "TRANSAKSI GUDANG - SUPERVISI BARANG KELUAR",
        transaksi_gudang_supervisi_barang_masuk: "TRANSAKSI GUDANG - SUPERVISI BARANG MASUK",
        transaksi_gudang_supervisi_retur_pelanggan: "TRANSAKSI GUDANG - SUPERVISI RETUR PELANGGAN",
        transaksi_gudang_supervisi_retur_pemasok: "TRANSAKSI GUDANG - SUPERVISI RETUR PEMASOK",

        AboutScreen: "Info",
        CatalogScreen: "Katalog",
        ClientScreen: "Pelanggan",
        ConversionScreen: "Konversi Barang",
        ItemInScreen: "Barang Masuk",
        ItemUseScreen: "Barang Keluar",
        KonsinyasiScreen: "Konsinyasi",
        ReqMaterialScreen: "Permintaan Barang",
        ReqReturnScreen: "Retur",
        StockScreen: "Stok",

        cashier: "Kasir",
        catalog: "Katalog",
        CategoryScreen: "Master Kategori",
        GoodsScreen: "Master Barang",
        IteminScreen: "Barang Masuk",
        ItemoutScreen: "Barang Keluar",
        reportselling: "Laporan Penjualan",
        RequestItemScreen: "Permintaan Barang",
        UnitScreen: "Master Satuan"
    },
}

export default id_master_profile;